import React, { Component } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import Badge from "react-bootstrap/Badge";
import "./Experience.scss";
import { 
  trackSectionView, 
  trackTimeOnSection, 
  trackExperienceView,
  trackExperienceExpand 
} from "../utils/analytics";

class Experience extends Component {
  constructor(props) {
    super(props);
    this.sectionRef = React.createRef();
    this.sectionStartTime = null;
    this.hasTrackedView = false;
  }

  componentDidMount() {
    this.setupIntersectionObserver();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.trackTimeSpent();
  }

  setupIntersectionObserver = () => {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.sectionStartTime = Date.now();
            if (!this.hasTrackedView) {
              trackSectionView('experience');
              trackExperienceView();
              this.hasTrackedView = true;
            }
          } else {
            this.trackTimeSpent();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (this.sectionRef.current) {
      this.observer.observe(this.sectionRef.current);
    }
  };

  trackTimeSpent = () => {
    if (this.sectionStartTime) {
      const timeSpent = Math.round((Date.now() - this.sectionStartTime) / 1000);
      if (timeSpent > 1) {
        trackTimeOnSection('experience', timeSpent);
      }
      this.sectionStartTime = null;
    }
  };

  handleExperienceExpand = (companyName, jobTitle) => {
    trackExperienceExpand(companyName, jobTitle);
  };
  render() {
    if (this.props.resumeExperience && this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.experience;
      var work = this.props.resumeExperience.map(function (work, i) {
        const technologies = work.technologies;
        const mainTechnologies = work.mainTech;

        var mainTech = mainTechnologies.map((technology, i) => {
          return (
            <span className="main-tech-badge" key={i}>
              {technology}
            </span>
          );
        });

        var tech = technologies.map((technology, i) => {
          return (
            <span className="tech-badge" key={i}>
              {technology}
            </span>
          );
        });

        return (
          <VerticalTimelineElement
            className="vertical-timeline-element--work modern-timeline-element"
            date={work.years}
            iconStyle={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              textAlign: "center",
              boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            contentStyle={{
              background: "white",
              borderRadius: "16px",
              boxShadow: "0 15px 35px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(102, 126, 234, 0.1)",
            }}
            contentArrowStyle={{
              borderRight: "7px solid rgba(102, 126, 234, 0.1)",
            }}
            icon={<i className="fas fa-briefcase"></i>}
            key={i}
          >
            <div className="experience-card-content">
              <div className="main-tech-container">{mainTech}</div>

              <h3 className="experience-title">{work.title}</h3>

              <h4 className="experience-company">{work.company}</h4>

              {work.description && (
                <p className="experience-description">{work.description}</p>
              )}

              <div className="tech-container">{tech}</div>
            </div>
          </VerticalTimelineElement>
        );
      });
    }

    return (
      <section className="experience-section" id="experience" ref={this.sectionRef}>
        <div className="container">
          <div className="experience-header">
            <h2 className="section-title">{sectionName}</h2>
            <div className="section-divider"></div>
            <p className="section-subtitle">
              My professional journey and the technologies I've mastered
            </p>
          </div>

          <div className="timeline-wrapper">
            <VerticalTimeline lineColor="rgba(102, 126, 234, 0.2)">
              {work}
              <VerticalTimelineElement
                iconStyle={{
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "#fff",
                  textAlign: "center",
                  boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                icon={<i className="fas fa-star"></i>}
              />
            </VerticalTimeline>
          </div>
        </div>
      </section>
    );
  }
}

export default Experience;
